<template>
  <main>
    <div class="container-fluid message page-note">
      <TopTemplate>
        <template #right-element>
          <router-link :to="{name: 'addNote'}" class="btn button btn-primary" :disabled="loading">
            <i class="icon-Add" />
            {{ $t("button.addNote") }}
          </router-link>
        </template>
        <template #left-element>
          <h3>{{ $t("title.listNote") }}</h3>
        </template>
      </TopTemplate>
      <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
        <div class="col-md-11 search searchTeacher">
          <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshTeacher()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>
        <div class="date-wrapper filter-wrapper" @click="showFilter()">
          <span>{{ $t("barFiltre.filtre") }}</span>
        </div>
      </div>
      <div v-if="showFil" class="row container-select container-filter">
        <div class="col-md-12">
          <div class="reset_student" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
        <div class="col-md-12">
          <p class="filter_critere">{{ $t("common.c_recherche") }}</p>
        </div>

        <!-- <div class="col-md-4 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.school_year"
            :options="school_year"
            :searchable="true"
            placeholder="Sélectionner l’année scolaire"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event)"
          >
            <template #no-options="{}">
              {{ $t("common.emptysearchCourse") }}
            </template>
          </v-select>
        </div> -->
        <div class="col-md-6 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.type_id"
            :options="classType"
            placeholder="Sélectionner le niveau"
            :searchable="true"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event), ChangeLevel($event)"
          >
            <template #no-options="{}">
              {{ $t("common.emptySystem") }}
            </template>
          </v-select>
        </div>
        <div class="col-md-6 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.class_id"
            :options="classes"
            :searchable="true"
            placeholder="Sélectionner la classe"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event)"
          >
            <template #no-options="{}">
              {{ $t("common.emptysearchClasse") }}
            </template>
          </v-select>
        </div>
      </div>
      <div v-if="loading" class="card mt-2 text-center d-block pt-2 pb-24">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div class="table teacher table-note" v-if="!loading && notes.length > 0">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <tr class="row">
                      <th class="col-md-3">{{ $t("notes.tab.class") }}</th>
                      <th class="col-md-2">{{ $t("notes.tab.annee") }}</th>
                      <th class="col-md-2 text-center">{{ $t("notes.tab.nbr_note") }}</th>
                      <th class="col-md-3 text-center">{{ $t("notes.tab.update") }}</th>
                      <th class="col-md-2 view">{{ $t("common.action") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="note in notes" :key="note.id" class="row">
                      <td class="col-md-3">
                        <p class="classe-title">{{ note.name }}</p>
                      </td>
                      <td class="col-md-2">
                        <p>{{ note.school_year }}</p>
                      </td>
                      <td class="col-md-2 text-center">
                        <p>{{ note.nbr_exam }}</p>
                      </td>
                      <td class="col-md-3 text-center">
                        <p v-if="note.updated_at">{{ dateTime(note.updated_at) }}</p>
                        <p v-else>-</p>
                      </td>

                      <td class="col-md-2 action">
                        <div
                          class="espace_height"
                          @click="
                            setDate(note.school_year);
                            setData(note);
                          "
                        >
                          <p>
                            <router-link
                              class="success_msg name_propre"
                              :to="{
                                name: 'Detailnote',
                                params: {id: note.id},
                              }"
                              @click="setItem()"
                            >
                              <i class="icon-eyes">
                                <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                              </i>
                            </router-link>
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-md-12 modal_dis">
                  <div class="col-md-12">
                    <div class="table__wrapper__pagination-wrapper">
                      <div class="pagination">
                        <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

  <script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import NoteService from "../../services/note.service";
import vSelect from "vue-select";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      pagination: {},
      total: 0,
      last_page: null,
      classes: [],
      showFil: false,
      params: {
        q: "",
        limit: 10,
        page: 1,
        sort: "",
        order: false,
        class_id: null,
        school_year: null,
        type_id: null,
        hasfilter: false,
      },
      notes: [],
      classType: [],
      school_year: [],
      moment: null,
      pageDetail: null,
    };
  },
  created() {
    this.moment = moment;
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.params.type_id = null;
        this.params.class_id = null;
        this.params.school_year = val.id;
        this.getFiltre();
        this.ListNote();
      }
    },
  },
  mounted() {
    this.pageDetail = localStorage.getItem("detail");
    if (this.getPassageYears.id) {
      this.params.school_year = this.getPassageYears.id;
      this.getFiltre();
      this.ListNote();
    }
  },
  methods: {
    setItem() {
      localStorage.setItem("detail", true); // Ajout de la page courante dans le localStorage
    },
    clearSavedPage() {
      localStorage.removeItem("detail"); // Suppression de l'élément du localStorage
    },

    ChangeLevel(e) {
      this.params.class_id = null;
    },
    Changeselectedfilter(e) {
      this.getFiltre();
      this.getResults();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    getFiltre() {
      this.loading = true;
      NoteService.getFilterNote({
        params: {
          type_id: this.params.type_id,
          school_year: this.params.school_year,
        },
      })
        .then(
          (response) => {
            this.classType = _.orderBy(response.data.class_type, "name");
            this.classes = _.orderBy(response.data.classes, "name");
            this.school_year = response.data.school_year;
            this.loading = false;
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    resetFilter() {
      this.params.type_id = null;
      this.params.class_id = null;
      this.getFiltre();
      this.ListNote();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListNote();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListNote();
    },
    setDate(date) {
      this.$store.commit("SET_DATE", date);
      const jsonString = JSON.stringify(date);
      localStorage.setItem("dateData", jsonString);
    },
    setData(data) {
      this.$store.commit("SET_DATA_CLASS", data);
      const jsonString = JSON.stringify(data);
      localStorage.setItem("dateDataClass", jsonString);
    },
    dateTime(value) {
      return moment(value).locale("fr").format("DD-MM-YYYY");
    },
    ListNote() {
      this.loading = true;
      NoteService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          class_id: this.params.class_id,
          school_year: this.params.school_year,
          type_id: this.params.type_id,
        },
      })
        .then(
          (response) => {
            this.notes = response.data.data;
            const savedPage = localStorage.getItem("currentPageNote");
            if (savedPage && this.pageDetail) {
              this.params.page = Number(savedPage);
              this.getResults(null, this.params.page);
            }

            this.pagination = this.makePagination(response.data.meta, response.data.links);
            this.total = response.data.meta.total;
            this.last_page = response.data.meta.last_page;
            this.loading = false;
          },
          (error) => {
            if (error.response && error.response.status === 403) {
              this.$router.push("/error-403");
            }
            this.loading = false;
          }
        )
        .finally(() => {
          this.clearSavedPage();
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null, param) {
      this.selected = [];
      if (param) {
        this.params.page = param;
      } else {
        this.params.page = !page ? this.params.page : page;
      }
      localStorage.setItem("currentPageNote", this.params.page); // Ajout de la page courante dans le localStorage
      this.loading = true;

      NoteService.getAll({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          class_id: this.params.class_id,
          type_id: this.params.type_id,
          school_year: this.params.school_year,
          course_id: this.params.course_id,
          action: this.selectedStatus,
        },
      })
        .then((response) => {
          this.notes = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    searshTeacher: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListNote();
      }
    }, 200),
  },
};
</script>

  <style lang="scss" scoped>
.page-note {
  .reset_student {
    color: #34b9bb;
    font-size: 14px;
    font-weight: 600;
  }
  .search-filter-wrapper {
    margin: 0 !important;
  }
  .filter_critere {
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .vs__search {
    &::placeholder {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
    }
  }
  .table-note {
    .table__wrapper {
      padding: 0 15px !important;
      .table {
        thead {
          tr {
            border-bottom-width: 3px;

            th {
              padding-top: 18px;
              padding-bottom: 18px;
              &:first-child {
                padding-left: 30px;
              }
              &:last-child {
                padding-right: 30px;
                padding-left: 0;
              }
            }
          }
        }
        tbody {
          tr {
            td {
              &:first-child {
                padding-left: 30px;
              }
              &:last-child {
                padding-right: 30px;
              }
              p {
                margin-top: 0;
                margin-bottom: 0;
                &.classe-title {
                  color: #333;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 600;
                }
              }
            }
          }
        }
        .action {
          text-align: center;
          p {
            padding: 13px;
          }
        }
        .view {
          text-align: center;
        }
      }
    }
  }
}
</style>
